export default __webpack_public_path__ + "static/media/Kontentino_LinkedIn_inspirations_calendar_tool.03d32c2c.svg";